import { render } from "./ViewUsersTrainees.vue?vue&type=template&id=d9389018&scoped=true"
import script from "./ViewUsersTrainees.vue?vue&type=script&lang=js"
export * from "./ViewUsersTrainees.vue?vue&type=script&lang=js"

import "./ViewUsersTrainees.vue?vue&type=style&index=0&id=d9389018&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9389018"]])

export default __exports__